/* eslint-disable max-len */
import React from 'react';

const iconHelp = () => (
  <svg
    width="20px"
    height="18px"
    viewBox="0 0 20 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-58.000000, -629.000000)">
        <g transform="translate(58.000000, 629.000000)">
          <path d="M0.833333333,17.5 L4.16666667,17.5 L4.16666667,7.5 L0.833333333,7.5 L0.833333333,17.5 L0.833333333,17.5 Z M19.1666667,8.33333333 C19.1666667,7.41666667 18.4166667,6.66666667 17.5,6.66666667 L12.2416667,6.66666667 L13.0333333,2.85833333 L13.0583333,2.59166667 C13.0583333,2.25 12.9166667,1.93333333 12.6916667,1.70833333 L11.8083333,0.833333333 L6.325,6.325 C6.01666667,6.625 5.83333333,7.04166667 5.83333333,7.5 L5.83333333,15.8333333 C5.83333333,16.75 6.58333333,17.5 7.5,17.5 L15,17.5 C15.6916667,17.5 16.2833333,17.0833333 16.5333333,16.4833333 L19.05,10.6083333 C19.125,10.4166667 19.1666667,10.2166667 19.1666667,10 L19.1666667,8.40833333 L19.1583333,8.4 L19.1666667,8.33333333 L19.1666667,8.33333333 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default iconHelp;
